export type SellerAddressUi = {
  street: string;
  streetError?: string;
  exteriorNumber: string;
  exteriorNumberError?: string;
  interiorNumber: string;
  interiorNumberError?: string;
  postalCode: string;
  postalCodeError?: string;
  colonia: string;
  coloniaError?: string;
  cancelDisabled?: boolean;
  saveDisabled?: boolean;
};

export const initialState: SellerAddressUi = {
  street: '',
  exteriorNumber: '',
  interiorNumber: '',
  postalCode: '',
  colonia: '',
  cancelDisabled: true,
  saveDisabled: true,
};
